/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable max-len */
import React from 'react';

function ApprovedBlock({ OrderDetails }) {
    return (
        <div className="border border-[#CBC7C7] rounded-md bg-[#F5F5FA] h-auto p-3 my-4">
            <p className="font-semibold text-base text-[#090406]">Approval</p>
            <button
                type="button"
                className=" border border-[#EFFFE8] py-1.5 px-9 bg-[#EFFFE8] text-xs12 font-semibold text-[#206C00] w-[110px] mt-2"
                style={{
                    padding: '8px 14px',
                    border: '1px solid #206C00',
                    borderRadius: '8px',
                    fontSize: '14px',
                    background: '#EFFFE8',
                }}
            >
                <span className="flex justify-between items-center">
                    <img src="/images/Vector-2.svg" />
                    {' '}
                    Approved
                </span>
                {' '}
            </button>
            <div className="relative">
                <textarea disabled name="" id="" value={OrderDetails?.approvals.approval[(OrderDetails?.approvals.approval.length - 1)].note} className="resize-none w-full mt-2.5 border border-[#CBCBCB] bg-[#fff] rounded-md px-2.5 py-3.5 h-[85px] custom-scrollbar outline-0 text-sm font-normal text-[#555259] placeholder:text-xs13 placeholder:font-normal placeholder:text-[#A1A1A1]" placeholder="" />
            </div>
        </div>
    );
}

export default ApprovedBlock;
